import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./Checkbox.module.scss";

const Checkbox = ({click, isBrand, handleCheck, isChecked, isHidden, id, customSelectStyle, largerCheckSize, checkBoxLabelStyling, disabled = false, uniqueCheckId, check}) => {
	let [isCheckedState, setCheckedState] = useState(false);
	const toggleChange = (event) => {
		if (click) {
			click(event, !isCheckedState);
		} else {
			setCheckedState((isCheckedState = !isCheckedState));
		}
		if (isBrand) {
			handleCheck(isCheckedState);
		}
	};

	useEffect(() => {
		setCheckedState(isChecked);
	}, [isChecked]);

	return (
		<>
			<div
				className={`${
					isHidden
						? styles["checkbox-hide"]
						: styles["checkbox-container"]
				}`}
			>
				<label
					className={` ${styles["checkbox-label"]} ${
						customSelectStyle ? "" : styles["checkbox-label--bold"]
					} ${largerCheckSize ? styles["checkbox-label--large"] : "e"}
					${styles[checkBoxLabelStyling]}
					${disabled ? styles.disabled: ""}`}
				>
					<input
						type="checkbox"
						name="check-one"
						id={id}
						checked={isCheckedState}
						value="check-one"
						onChange={(event) => toggleChange(event)}
						className={styles["checkbox-input"]}
						uniqueid={uniqueCheckId}
						disabled={disabled}
					/>
					<span className={styles["checkbox-span"]}>
						<label className={styles["span-text"]}>{check}</label>
					</span>
				</label>
			</div>
		</>
	);
};

Checkbox.propTypes = {
	check: PropTypes.string.isRequired,
	count: PropTypes.string,
	click: PropTypes.func,
	id: PropTypes.string,
	isChecked: PropTypes.bool,
	isHidden: PropTypes.bool,
	customSelectStyle: PropTypes.bool,
	largerCheckSize: PropTypes.bool,
	isBrand: PropTypes.any,
	handleCheck: PropTypes.func,
	checkBoxLabelStyling: PropTypes.string,
	uniqueCheckId: PropTypes.string,
	disabled: PropTypes.bool,
};

export default Checkbox;
